import { render, staticRenderFns } from "./StockPriceList.vue?vue&type=template&id=de96050a&scoped=true"
import script from "./StockPriceList.vue?vue&type=script&lang=js"
export * from "./StockPriceList.vue?vue&type=script&lang=js"
import style0 from "./StockPriceList.vue?vue&type=style&index=0&id=de96050a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de96050a",
  null
  
)

export default component.exports